// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".language-radio-buttons[data-v-337a1fb1] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}", "",{"version":3,"sources":["/builds/front/game-platform-web/src/components/LanguageRadioButtons/index.vue"],"names":[],"mappings":"AACA;EACE,2BAAA;EAAA,2BAAA;EAAA,oBAAA;AAAF","file":"index.vue","sourcesContent":["\n.language-radio-buttons {\n  display: inline-flex;\n}\n"]}]);
// Exports
module.exports = exports;
